(() => {
  function init(root = document) {
    root.querySelectorAll('[data-emenne-set]').forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const products = JSON.parse(el.querySelector('[data-set-products]').textContent);
      const bundles = JSON.parse(el.querySelector('[data-set-bundles]').textContent);
      const form = el.querySelector('form');
      const color = form.elements.color;
      const area = el.querySelector('[data-set-sizes]');
      const button = form.querySelector('button[type=submit]');
      const status = form.querySelector('[role=status]');
      const price = el.querySelector('[data-set-price]');
      const pieces = [
        { key: 'organic-cotton-sports-bra', label: 'Sports Bra' },
        { key: 'organic-cotton-foldover-flare-leggings', label: 'Foldover Flare Leggings' },
        { key: 'bamboo-wrap-top', label: 'Ballet Blouse' }
      ];
      let active = [];
      let selectedBundleVariant = null;
      const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: el.dataset.currency
      }).format(cents / 100);

      const displayPercent = (regular, discounted) => Math.round((regular-discounted)/regular*100);
      const topPrice = el.querySelector('[data-set-top-price]');
      function showTopPrice(variant, regularTotal, from = false) {
        topPrice.replaceChildren();
        if (!variant) return;
        if (regularTotal > variant.price && !from) {
          const original = document.createElement('s');
          original.textContent = money(regularTotal);
          topPrice.append(original);
        }
        const current = document.createElement('strong');
        current.textContent = (from ? 'From ' : '') + money(variant.price);
        topPrice.append(current);
        if (regularTotal > variant.price && !from) {
          const saving = document.createElement('span');
          saving.className = 'em-set-saving-label';
          saving.textContent = displayPercent(regularTotal, variant.price) + '% off';
          topPrice.append(saving);
        }
      }
      function previewPrice() {
        const available = (bundles[color.value]?.variants || []).filter(v => v.available);
        const candidate = [...available].sort((a,b) => a.price-b.price)[0];
        const order = [2,1,0];
        const regular = candidate ? active.reduce((sum, product, i) => {
          const variant = product?.variants.find(v => v.title === candidate.options?.[order[i]]);
          return sum + (variant?.price || 0);
        }, 0) : 0;
        const variable = available.some(v => v.price !== candidate?.price) || active.some(p => p?.variants.some(v => v.price !== p.variants[0]?.price));
        showTopPrice(candidate, regular, variable);
      }
      function update() {
        const selections = [...area.querySelectorAll('select')];
        selectedBundleVariant = null;
        if (selections.length !== 3 || selections.some((s) => !s.value)) {
          button.disabled = true;
          price.textContent = 'Select a size for each item.';
          previewPrice();
          return;
        }
        const [braSize, leggingsSize, blouseSize] = selections.map((s) => s.selectedOptions[0].textContent.replace(/ — Sold out$/, ''));
        const bundle = bundles[color.value];
        // Shopify Bundles created these options in blouse, leggings, bra order.
        selectedBundleVariant = bundle?.variants.find((variant) =>
          variant.options?.[0] === blouseSize &&
          variant.options?.[1] === leggingsSize &&
          variant.options?.[2] === braSize
        ) || null;
        if (!selectedBundleVariant || !selectedBundleVariant.available) {
          button.disabled = true;
          topPrice.replaceChildren();
          price.textContent = bundle ? 'This size combination is currently unavailable.' : 'This set is currently unavailable.';
          return;
        }
        button.disabled = false;
        const regularTotal = selections.reduce((sum, select, i) => {
          const variant = active[i]?.variants.find((v) => String(v.id) === select.value);
          return sum + (variant?.price || 0);
        }, 0);
        const bundlePrice = selectedBundleVariant.price;
        showTopPrice(selectedBundleVariant, regularTotal);
        if (regularTotal > bundlePrice) {
          const percent = displayPercent(regularTotal, bundlePrice);
          price.innerHTML = '<span class="em-set-savings">Set discount <strong>' + percent +
            '%</strong></span><span class="em-set-price-final">Total <strong>' + money(bundlePrice) + '</strong></span>';
        } else {
          price.innerHTML = '<span class="em-set-price-final">Total <strong>' + money(bundlePrice) + '</strong></span>';
        }
      }

      function render() {
        area.replaceChildren();
        active = [];
        status.textContent = '';
        el.dataset.selectedColor = color.value;
        for (const piece of pieces) {
          const product = products[piece.key + '-' + color.value];
          let garmentName = product?.title || piece.label;
          const vendorName = (product?.vendor || '').trim().toLowerCase();
          if (vendorName) {
            for (const separator of [' | ', ' - ', ' — ', ' – ']) {
              const parts = garmentName.split(separator);
              if (parts.length > 1 && parts[parts.length-1].trim().toLowerCase() === vendorName) {
                parts.pop(); garmentName = parts.join(separator).trim(); break;
              }
            }
          }
          active.push(product);
          const field = document.createElement('div');
          field.className = 'em-set-garment';
          const imageLink = document.createElement('a');
          imageLink.className = 'em-set-garment-image';
          if (product) {
            imageLink.href = (window.Shopify?.routes?.root || '/') + 'products/' + product.handle;
            imageLink.setAttribute('aria-label', 'View ' + garmentName);
            const source = product.featured_image || product.images?.[0];
            if (source) {
              const image = document.createElement('img');
              image.src = typeof source === 'string' ? source : source.src;
              image.alt = garmentName;
              image.width = 80; image.height = 106; image.loading = 'lazy';
              imageLink.append(image);
            }
          }
          field.append(imageLink);
          const choices = document.createElement('fieldset');
          const legend = document.createElement('legend');
          legend.textContent = garmentName;
          choices.append(legend);
          const pills = document.createElement('div');
          pills.className = 'em-set-size-pills';
          choices.append(pills);
          const select = document.createElement('select');
          select.hidden = true;
          select.tabIndex = -1;
          select.setAttribute('aria-hidden', 'true');
          select.name = piece.key;
          select.add(new Option('Choose your size', ''));
          if (product) {
            for (const variant of product.variants) {
              const opt = new Option(variant.title + (variant.available ? '' : ' — Sold out'), variant.id);
              opt.disabled = !variant.available;
              select.add(opt);
              const label = document.createElement('label');
              const radio = document.createElement('input');
              radio.type = 'radio'; radio.name = piece.key + '-size'; radio.value = variant.id;
              radio.disabled = !variant.available;
              radio.setAttribute('aria-label', garmentName + ', ' + variant.title + (variant.available ? '' : ', sold out'));
              const text = document.createElement('span'); text.textContent = variant.title;
              label.append(radio, text); pills.append(label);
              radio.addEventListener('change', () => { select.value = radio.value; update(); });
            }
          } else {
            status.textContent = 'This color is currently unavailable.';
          }
          field.append(choices, select);
          area.append(field);
          select.addEventListener('change', update);
        }
        update();
      }

      form.querySelectorAll('[name="set_color"]').forEach(radio => radio.addEventListener('change', () => {
        color.value = radio.value;
        render();
      }));
      color.addEventListener('change', render);
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (button.disabled || !selectedBundleVariant) return;
        button.disabled = true;
        status.textContent = 'Adding your set…';
        try {
          const response = await fetch(el.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: selectedBundleVariant.id, quantity: 1 }] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Unable to add the set. Please check availability.');
          window.location.assign(el.dataset.cartUrl);
        } catch (error) {
          status.textContent = error.message;
          update();
        }
      });
      render();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
